import React from "react";
import { Virtuoso } from "react-virtuoso";

import MyBetsEmptyState from "../emptyState";
import { BetsVirtualListProps } from "./types";

const BetsVirtualList = ({
  itemContent,
  modalScrollableRef,
  bets
}: BetsVirtualListProps) => {
  if (!bets.length) {
    return <MyBetsEmptyState />;
  }

  return (
    <Virtuoso
      data={bets}
      overscan={100}
      itemContent={itemContent}
      // @ts-ignore
      customScrollParent={modalScrollableRef}
    />
  );
};

export default BetsVirtualList;
